import { push } from '@lagunovsky/redux-react-router'
import { useState } from 'react'
import Container from 'react-bootstrap/Container'
import { useDispatch } from 'react-redux'

import { CINEMA_NAMES } from 'global/helpers/cinemaList'
import ChooseCinemaDesktop from './components/ChooseCinemaDesktop/ChooseCinemaDesktop'
import ChooseCinemaMobile from './components/ChooseCinemaMobile/ChooseCinemaMobile'

const LANG = 'cz/'

const ChooseCinemaContent = ({ currentCinema }) => {
    const [selectedCinema, setSelectedCinema] = useState(currentCinema)
    const dispatch = useDispatch()

    const baseUrl = process.env.REACT_APP_WEB_PORTAL_URL

    const selectCinemaHandler = (cinema) => {
        setSelectedCinema(cinema)
    }

    const confirmHandler = (cinema) => {
        dispatch(push(`${baseUrl}${LANG}${cinema.slug}`))
    }

    return (
        <Container fluid>
            <ChooseCinemaMobile
                cinemas={CINEMA_NAMES}
                currentCinema={currentCinema}
                selectedCinema={selectedCinema}
                selectCinemaHandler={selectCinemaHandler}
                confirmHandler={confirmHandler}
            />
            <ChooseCinemaDesktop
                cinemas={CINEMA_NAMES}
                selectedCinema={selectedCinema}
                selectCinemaHandler={selectCinemaHandler}
                confirmHandler={confirmHandler}
            />
        </Container>
    )
}

export default ChooseCinemaContent
